import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';
import { statusCheck } from '../public';
import Swal from 'sweetalert2';
import { all } from 'axios';


export const useFleetStore = defineStore('fleet', {
  state: () => ({
    fleets: [],
    allFleets: [],
    totalEntries: 0,
    currentPage: 1,
    itemsPerPage: 10,
    sort_by:'fleet_id',
    order:'desc',
  }),
  actions: {
    async fetchFleets() {
      const url = `/api/admin/fleet/list?per_page=${this.itemsPerPage}&page=${this.currentPage}&sort_by=${this.sort_by}&order=${this.order}`;
      try {
        const response = await useHttp().get(url);
        this.fleets = response.data.fleets;
        this.totalEntries = response.data.total;
      } catch (error) {
        console.error('Error fetching members:', error);
        throw error;
      }
    },
    async createFleet(payload) {
        try {
          const response = await useHttp().post('/api/admin/fleet/create', payload);
            if(statusCheck(response.data)){
                Swal.fire({
                    icon: "success",
                    title: response.data.message ,
                    showConfirmButton: false,
                    timer: 1500
                });
                this.fetchFleets(); // 成功後刷新成員列表
            }
        } catch (error) {
          console.error('Error creating member:', error);
          throw error;
        }
    },
    async updateFleet(payload) {
      try {
        const response = await useHttp().post('/api/admin/fleet/update', payload);
        if(statusCheck(response.data)){
          Swal.fire({
            icon: 'success',
            title: response.data.message ,
            showConfirmButton: false,
            timer: 1500
          });
        await this.fetchFleets();  // 更新後重新加載成員列表
      }
      } catch (error) {
        console.error('Error updating member:', error);
        throw error;
      }
    },
    async fetchFleetForSelect() {
      try {
        const response = await useHttp().get('/api/admin/fleet/all');
        this.allFleets = response.data.fleets;
      } catch (error) {
        console.error('Error fetching fleets:', error);
        throw error;
      }
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchFleets();
      }
    },
  },
  getters: {
    paginatedData(state) {
      return state.fleets;
    },
    totalPages(state) {
      return Math.ceil(state.totalEntries / state.itemsPerPage);
    },
  },
});
